import { Validators } from '@angular/forms';

import { ComponentTypesEnum } from '../../../app/shared/enums';
import { AmountControl, SelectControl } from '../../../app/shared/classes';
import { DialogButtonTypesEnum, DialogConfigInterface } from '../../../app/shared/components';

export const FundOrderSellQuantitySelector = 'fundOrderSellQuantity';
export const FundOrderSellProductSelector = 'fundOrderSellProducts';

export interface FundOrderSellControlsInterface {
    quantity: AmountControl;
    product: SelectControl;
}

export const FundOrderSellComponentControls = (isMutualFund: boolean): FundOrderSellControlsInterface => {
    return {
        product: new SelectControl({
            name: FundOrderSellProductSelector,
            value: null,
            placeholder: 'Product name',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.Select,
            options: []
        }),
        quantity: new AmountControl({
            name: FundOrderSellQuantitySelector,
            value: null,
            placeholder: isMutualFund ? 'Number of shares' : 'Face value to sell',
            validators: [Validators.required],
            componentType: ComponentTypesEnum.AmountInput,
            currency: null,
            fourDecimals: isMutualFund
        })
    };
};

export const FundOrderSellDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false
    };
};
